<template>
  <svg
    class="custom-icon"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.0657 0.101905C7.49489 2.50022 4.02283 7.03267 4.02283 7.03267C3.315 6.24687 2.56714 5.50321 1.78266 4.80508C1.57692 4.62215 1.31507 4.52669 1.04738 4.53704C0.77969 4.54738 0.525011 4.6628 0.332228 4.86113C0.139444 5.05946 0.0221397 5.32674 0.00282917 5.61166C-0.0164814 5.89658 0.0635625 6.17907 0.227598 6.40491C1.34418 7.95368 2.31542 9.61567 3.1273 11.367C3.21523 11.5552 3.35015 11.7138 3.51722 11.8255C3.68429 11.9372 3.87701 11.9976 4.07418 11.9999C4.27134 12.0023 4.46529 11.9466 4.63467 11.8389C4.80406 11.7313 4.9423 11.5759 5.03417 11.3898C7.25497 6.93453 9.17812 4.43693 11.8558 1.06669C11.9498 0.948443 12.001 0.798122 12 0.643048C11.999 0.487975 11.9458 0.338444 11.8501 0.221639C11.7545 0.104833 11.6227 0.0285075 11.4787 0.00653522C11.3348 -0.015437 11.1882 0.0184032 11.0657 0.101905Z"
      fill="#42C186"
    />
  </svg>
</template>
